/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Trash",
  size: 20
}

const SvgTrash = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path fill="none" d="M6.5 3V1.5h7V3M4.5 4v14.5h11V4" />
    <path d="M8 7h1v9H8zM11 7h1v9h-1zM2 3h16v1H2z" />
  </Svg>
)

SvgTrash.defaultProps = defaultProps
export default SvgTrash
